import { Box, Button, CircularProgress } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import LogoutIcon from "@mui/icons-material/Logout";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../common/constants";
import Notifier from "../common/Notifier";
import { signInWithGoogle, signOutUser } from "../common/auth";

const Login = ({ user, authLoading }) => {
  const navigate = useNavigate();

  const onClickLogin = async () => {
    try {
      await signInWithGoogle();
      navigate(APP_ROUTES.home);
    } catch (error) {
      console.error("Login error:", error);
      Notifier.notify("snackbar", { content: "Login failed. Please try again." });
    }
  };

  const onClickLogout = async () => {
    try {
      await signOutUser();
      Notifier.notify("snackbar", { content: "Logged out successfully" });
    } catch (error) {
      console.error("Logout error:", error);
      Notifier.notify("snackbar", { content: "Logout failed" });
    }
  };

  if (authLoading) {
    return (
      <div className="login">
        <CircularProgress />
      </div>
    );
  }

  return (
    <div className="login">
      <h1>{user ? "Welcome" : "Login"}</h1>
      {user && (
        <p style={{ marginBottom: "1rem" }}>{user.email}</p>
      )}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        {!user && (
          <Button
            color="primary"
            variant="contained"
            onClick={onClickLogin}
            startIcon={<GoogleIcon />}
          >
            Sign in with Google
          </Button>
        )}
        {user && (
          <Button
            color="error"
            variant="contained"
            onClick={onClickLogout}
            startIcon={<LogoutIcon />}
          >
            Logout
          </Button>
        )}
      </Box>
    </div>
  );
};

export default Login;
